import React, { createContext, FC, PropsWithChildren, useContext } from 'react'

import Auth from '@themenu/auth'

import { useQueryStringFlag } from '../hooks/useQueryStringFlag'

const WHITELISTED_HOSTNAMES = ['local', 'staging']

type BetaTestContextType = {
  showBeta: boolean
  showSwitch: boolean
  switchBeta: VoidFunction
}

const BetaTestContext = createContext<BetaTestContextType>({
  showBeta: false,
  showSwitch: false,
  switchBeta: () => undefined,
})

export const useBetaTestContext = (): BetaTestContextType => useContext(BetaTestContext)

export const BetaTestProvider: FC<PropsWithChildren<{ defaultValue?: boolean; token: string }>> = ({
  children,
  defaultValue = false,
  token,
}) => {
  const [showBeta, setParam] = useQueryStringFlag(`beta:${token}`, defaultValue)

  return (
    <BetaTestContext.Provider
      value={{
        showBeta: showBeta ?? false,
        showSwitch:
          // show switch to disable redesign if already enabled
          showBeta ||
          // show switch during development & staging
          WHITELISTED_HOSTNAMES.some((str) => window.location.hostname.includes(str)) ||
          // show switch for sudoers in prod
          Auth.isSudo(),
        switchBeta: () => setParam(!showBeta),
      }}
    >
      {children}
    </BetaTestContext.Provider>
  )
}
